import { CERTA_API_URL } from 'config';
import { postWithResponse } from './fetch';

import { LoginRequest } from 'types/api/login-request';
import { LoginResponse } from 'types/api/login-response';
import { Guid } from 'types/guid';

export async function login(tenantId: Guid, username: string, password: string, 
                            barcode: string, pin: string, issueBackgroundToken: boolean): Promise<LoginResponse> {
  const request = {
    tenantId,
    username,
    password,
    barcode,
    pin,
    issueBackgroundToken
  } as LoginRequest;

  const response = await postWithResponse<LoginResponse>(CERTA_API_URL + '/login', request, undefined, tenantId);
  // const response = await postWithResponse<LoginResponse>('http://localhost:5001/exploration-pocs/us-central1/proxy' + '/login', request, undefined, tenantId);
  return response;
}


// WEBPACK FOOTER //
// ./src/api/login-api.ts